import React from "react";
import TrackVisibility from "react-on-screen";
import Skill from "../Items/Skill";

const skillData = {
  skillContent:
    "I'm so passionate about contributing my skills to the progress of any Organization I find myself. I also learn very fast incase there is a need to utilize a new tool for better result.",
  progressData: [
    {
      id: 1,
      name: "HTML5 & CSS",
      percentage: 85,
    },
    {
      id: 2,
      name: "Bootstrap 5, Tailwind, SASS, Material UI",
      percentage: 80,
    },
    {
      id: 3,
      name: "JavaScript (AJAX, jQuery)",
      percentage: 90,
    },
    {
      id: 4,
      name: "React Js (Redux & Next.Js)",
      percentage: 80,
    },
    {
      id: 5,
      name: "Laravel and PHP Core",
      percentage: 70,
    },
    {
      id: 6,
      name: "Database Management Systems (SQL)",
      percentage: 70,
    },
    {
      id: 7,
      name: "Content Management System (Wordpress)",
      percentage: 85,
    },
    {
      id: 8,
      name: "Git",
      percentage: 85,
    },
  ],
};

function Skills() {
  return (
    <>
      <p className="mb-0">{skillData.skillContent}</p>
      <div className="mt-5">
        <div className="row -mt-50">
          {skillData.progressData.map((progress) => (
            <div className="col-md-6 mt-50" key={progress.id}>
              <TrackVisibility once>
                <Skill progress={progress} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skills;
